// T039 — Navigation event definitions.
// Each event definition is a plain object with a `name` and a TypeScript
// phantom type for its properties, enforced via the EventDefinition generic.

// Use `type` (not `interface`) so the type satisfies Record<string, unknown>
// without requiring an explicit index signature.
export type PageViewedProperties = {
  path: string;
  referrer: string;
  utm_source?: string;
};

export type EventDefinition<TProperties extends Record<string, unknown>> = {
  name: string;
  _phantom?: TProperties;
};

export const PAGE_VIEWED: EventDefinition<PageViewedProperties> = {
  name: 'page_viewed',
};
